// extracted by mini-css-extract-plugin
export default {"TabPanel":"TabPanel_TabPanel__kjXpC"};